import React from 'react';
import '../App.css';
import './arborist.css';
import { IoSchoolOutline } from "react-icons/io5";
import { LuShieldAlert } from "react-icons/lu";
import { GiTreeBranch } from "react-icons/gi";
import { TbTrees } from "react-icons/tb";

const Arborist = () => {
	return (
		<div id="moduletwo_and_half9">
                        <div id='centerdiv_index9'>
                            <div id='moduletwo_and_half_picdiv9'></div>
                                <div id='moduletwo_and_half_title9'>
                                    <div id='icon_two_half9'>
                                        <div id='two_half_text19'><h1> - - - - - -&nbsp;&nbsp;</h1>
                                        </div><div id='icon_two_half_icon9'></div>
                                        <div id='two_half_text29'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
                                    </div>
                                    </div>
                                    <div id='two_half_text39'>
                                        <h1>Certified Arborist Tree Service</h1>
                                        <p>At SAM'S Tree Service, you will have the 
                                            privilege of working directly with an ISA 
                                            Certified Arborist! </p>
                                            <h3>Why should you choose 
                                            an ISA Certified Arborist for your tree 
                                            care needs?</h3>
                                    </div>
                                
                                {/*<div id='centerdiv_index9'>*/}
                                <div id='moduletwo_and_half_text_container9'>
                                    <div className='moduletwo_and_half_text9'>
                                        <div className='circle_div9'><IoSchoolOutline/></div>
                                        <div className='inside_text9' id='insideeDiv_moduletwo_and_half_text19'>
                                            <h1>Extensive Knowledge and Training</h1>
                                                <p> An ISA certified arborist possesses a vast 
                                                    knowledge base and specialized training in 
                                                    all aspects of arboriculture. From tree biology 
                                                    to maintenance practices and safety procedures, 
                                                    these tree specialist professionals have undergone rigorous 
                                                    examinations to demonstrate their high level of 
                                                    competence in tree care.
                                                </p>
                                        
                                        </div>
                                    </div>
                                <div className='moduletwo_and_half_text9'>
                                    <div className='circle_div9'><LuShieldAlert /></div>
                                    <div className='inside_text9' id='insideeDiv_moduletwo_and_half_text29'>
                                        <h1>Safety</h1>
                                        <p> ISA certified arborists offer a wide range of 
                                            services, including pruning, removal, fertilization, 
                                            pest and disease monitoring, and expert advice on 
                                            all things tree-related. With their wealth of 
                                            knowledge and expertise, they can perform these 
                                            tasks safely and efficiently.
                                        </p>
                                    </div>
                                    </div>
                                <div className='moduletwo_and_half_text9'>
                                    <div className='circle_div9'><GiTreeBranch /></div>
                                    <div className='inside_text9' id='insideeDiv_moduletwo_and_half_text39'>
                                        <h1>Comprehensive Services</h1>
                                        <p> ISA certified arborists provide a 
                                            comprehensive range of services, such 
                                            as pruning, removal, fertilization, pest 
                                            and disease monitoring, and consultation 
                                            on tree-related issues. Their knowledge 
                                            and expertise enable them to carry out these 
                                            tasks efficiently and safely.
                                        </p>
                                    </div>
                                </div>
                                <div className='moduletwo_and_half_text9'>
                                    <div className='circle_div9'><TbTrees /></div>
                                    <div className='inside_text9' id='insideeDiv_moduletwo_and_half_text49'>
                                        <h1>Long-term Health of Your Trees</h1>
                                        <p> Trees are a long-term investment, and an 
                                            ISA certified arborist understands this. 
                                            They work diligently to ensure the longevity 
                                            of your trees by diagnosing and treating any 
                                            diseases or pest issues that may be affecting 
                                            them. Trusting your tree care needs to an ISA 
                                            certified arborist guarantees the health and 
                                            well-being of your trees for years to come.
                                        </p>
                                    </div>
                                </div>
                                </div>
                                <div id='moduletwo_and_halfpic'></div>
                                </div>
                        </div>
	);
};

export default Arborist;